import { Config } from '../_config'
import { Cookie, Response } from './Cookie'

import Cookies from 'js-cookie'

export class WindowCookie extends Cookie {
  static create({ config }: { config: Config }) {
    return new WindowCookie(config)
  }

  static document() {
    return document
  }

  constructor(private config: Config) {
    super()

    const cookieString = this.config.get('COOKIES_STRING')
    this.cookieParsed = this.parse({ cookie: cookieString || WindowCookie.document().cookie })
  }

  save<T extends string>({ key, value }: { key: string; value: string }): Response<T> {
    this.set(key, value)
    this.cookieParsed = this.parse({ cookie: WindowCookie.document().cookie })
    return [undefined, value as T]
  }

  private set(key: string, value: string) {
    Cookies.set(key, value)
  }

  decode<T extends string>({ value }: { value: string }): T {
    return atob(value) as T
  }
}
